<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    temporary
    right
    :width="width"
  >
    <v-list-item>
      <v-list-item-avatar>
        <v-icon>mdi-cart</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-if="cartItems.length> 0">Votre panier : {{ totalCart | toPrice(2, '€ HT') }}</v-list-item-title>
        <v-list-item-title v-else>Votre panier</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <div v-if="cartItems.length > 0">
      <Items></Items>

      <div class="text-center mt-10">
        <v-btn 
          large
          color="primary"
          :to="{name:'ShowCart'}"
        >
          Voir mon panier
        </v-btn>
      </div>
    </div>
    <div 
      v-else 
      class="text-center mt-10"
    >
      <span>Votre panier est vide</span>
    </div>

  </v-navigation-drawer>
</template>

<script>
  // COMPONENTS
  import Items from './Items'
  // EVENTS
  import { SET_CART_VISIBILITY } from '@/store/actions/cart'
  // VUEX
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'Drawer',

    components: {
      Items,
    },
    
    computed: {
      ...mapGetters({
        totalCart: 'getCartTotal',
        cartItems: 'getItems',
      }),
      
      drawer: {
        get() {
          return this.$store.getters.isCartShown
        },
        set(value) {
          this.$store.commit(SET_CART_VISIBILITY, value)
        },
      },
      width() {
        if (window.innerWidth > 996) {
          return 400
        } else {
          return 320
        }
      }
    }
  }
</script>

<style scoped>
  .total {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }
</style>